import { useContext } from 'react';

import MatrixDeviceVerificationContext from './MatrixDeviceVerificationContext';

const useMatrixDeviceVerificationContext = () => {
  const context = useContext(MatrixDeviceVerificationContext);
  if (!context) {
    throw new Error('useMatrixDeviceVerificationContext must be used within a MatrixDeviceVerificationProvider');
  }
  return context;
};

export default useMatrixDeviceVerificationContext;
